import gql from "graphql-tag";

const addressTypeQuery = `
    entryAddressTypes {
        id
        description
    }
    fromAddresses {
        id,
        fromName,
        fromAddress,
        description
    }
`;

const mergeTagQuery = `
    communication {
        unlayerMergeTags(context: $context)
    }
`;

const additionalSecurityUserAddressesQuery = `
    communication {
        additionalDynamicAddresses(context: $context){
            key,
            value
        }
    }
`;

const featuresQuery = `
    featureFlag{
          enableGraphQLDynamicTextValidationEndpoint
    }
`;

export const emailWizardInitQuery = gql`
    query($context: String!) {
        ${addressTypeQuery}
        ${mergeTagQuery}
        ${additionalSecurityUserAddressesQuery}
        ${featuresQuery}
    }
`;
